const styles = {
  container: {
    backgroundColor: 'background.default',
    width: '100%',
  },

  summaryList: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    '&.active .MuiListItemText-root:last-child': {
      '& p': {
        fontWeight: '550',
      },
    },
  },

  backButton: {
    position: 'absolute',
    left: 0,
    '& .MuiSvgIcon-root': {
      fontSize: { xs: 16, sm: 18 },
      fontWeight: 400,
      ml: 0.5,
      color: 'text.primaryDark',
    },
  },

  summaryListItem: {
    flex: 'initial',
    '& p': {
      marginRight: 0.5,
      textTransform: 'capitalize',
      fontSize: { xs: '9px!important', md: '13px!important' },
    },
    ':nth-of-type(+n+2)': {
      'p::before': {
        content: '" • "',
      },
    },
    '&.active': {
      '& p': {
        fontWeight: '400',
      },
    },
    '& svg path': {
      fill: 'red!important',
    },
  },
}

export default styles
